import React, { Component } from "react";
import axios from "axios";
import styled from "styled-components";
import { withRouter } from "react-router-dom";

import PageTitle from "../../../commons/components/PageTitle";
import InputErrorMsgWrapper from "../../../commons/components/input/InputErrorWrap";
import { ROUTES } from "../../../commons/constants/routes/routes";

class NoticeCreate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editId: null,
      title: "",
      content: "",
      validationErrors: {},
      isSubmitting: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const parts = window.location.pathname.split("/");
    const editIdx = parts.indexOf("edit");
    if (editIdx !== -1 && parts[editIdx + 1]) {
      const id = parts[editIdx + 1];
      this.setState({ editId: id });
      this.loadNotice(id);
    }
  }

  async loadNotice(id) {
    try {
      const res = await axios.get(`/cst/api/notice/${id}`);
      const d = res.data;
      this.setState({ title: d.title || "", content: d.content || "" });
    } catch (e) {
      console.log(e);
    }
  }

  validateForm() {
    const { title, content } = this.state;
    const validationErrors = {};
    if (!title.trim()) validationErrors.title = "제목을 입력해주세요.";
    if (!content.trim()) validationErrors.content = "내용을 입력해주세요.";
    if (Object.keys(validationErrors).length > 0) {
      this.setState({ validationErrors });
      return false;
    }
    return true;
  }

  async handleSubmit(e) {
    e.preventDefault();
    if (!this.validateForm()) return;

    const { editId, title, content } = this.state;
    this.setState({ isSubmitting: true });

    try {
      if (editId) {
        await axios.put("/adm/api/notice", { id: Number(editId), title, content });
      } else {
        await axios.post("/adm/api/notice", { title, content });
      }
      this.props.history.push(ROUTES.NOTICE.MAIN);
    } catch (err) {
      console.log(err);
    } finally {
      this.setState({ isSubmitting: false });
    }
  }

  clearError(field) {
    const { validationErrors } = this.state;
    delete validationErrors[field];
    this.setState({ validationErrors });
  }

  render() {
    const { editId, title, content, validationErrors, isSubmitting } = this.state;
    const isEdit = !!editId;

    return (
      <>
        <PageTitle title="공지사항" location={isEdit ? "공지 수정" : "공지 등록"} />
        <FormWrapper onSubmit={this.handleSubmit}>
          <FormContainer>
            <FormBox>
              <FormHead required>제목</FormHead>
              <FormBody>
                <InputErrorMsgWrapper
                  isError={validationErrors.title}
                  message={validationErrors.title}
                >
                  <input
                    type="text"
                    className="comm-inp"
                    placeholder="제목을 입력하세요"
                    value={title}
                    onChange={(e) => {
                      this.clearError("title");
                      this.setState({ title: e.target.value });
                    }}
                  />
                </InputErrorMsgWrapper>
              </FormBody>
            </FormBox>

            <FormBox className="content-box">
              <FormHead required>내용</FormHead>
              <FormBody>
                <InputErrorMsgWrapper
                  isError={validationErrors.content}
                  message={validationErrors.content}
                >
                  <ContentTextarea
                    placeholder="내용을 입력하세요"
                    value={content}
                    rows={12}
                    onChange={(e) => {
                      this.clearError("content");
                      this.setState({ content: e.target.value });
                    }}
                  />
                </InputErrorMsgWrapper>
              </FormBody>
            </FormBox>
          </FormContainer>

          <BtnGroup>
            <button
              type="button"
              onClick={() => this.props.history.push(ROUTES.NOTICE.MAIN)}
            >
              취소
            </button>
            <button type="submit" disabled={isSubmitting}>
              {isEdit ? "수정" : "저장"}
            </button>
          </BtnGroup>
        </FormWrapper>
      </>
    );
  }
}

const FormWrapper = styled.form`
  width: 1176px;
  margin: 55px auto 120px;
`;
const FormContainer = styled.div`
  max-width: 1176px;
  width: 100%;
  margin: 55px auto 20px;
  border: 1px solid #4b515b;
  border-width: 1px 0 1px;
`;
const FormBox = styled.div`
  padding: 24px 0;
  border-bottom: 1px solid #e3e5e7;
  display: flex;
  align-items: flex-start;
  &.content-box {
    align-items: flex-start;
  }
`;
const FormHead = styled.p`
  width: 140px;
  flex-shrink: 0;
  font-size: 16px;
  color: #191919;
  font-weight: 600;
  padding-left: 12px;
  padding-top: 8px;
  ${({ required }) =>
    required &&
    `&::after {
      content: " *";
      color: #FF5353;
    }`}
`;
const FormBody = styled.div`
  flex: 1;
  input,
  select {
    border-radius: 4px;
  }
  .comm-inp {
    width: 700px;
  }
`;
const ContentTextarea = styled.textarea`
  width: 700px;
  padding: 12px;
  border: 1px solid #d5d8de;
  border-radius: 4px;
  font-size: 15px;
  line-height: 1.6;
  resize: vertical;
  font-family: inherit;
  &:focus {
    outline: none;
    border-color: var(--secondary-500);
  }
`;
const BtnGroup = styled.div`
  max-width: 1176px;
  width: 100%;
  text-align: right;
  margin: 0 auto;
  button {
    width: 120px;
    font-size: 14px;
    padding: 10px 0;
    text-align: center;
    border-radius: 5px;
    font-weight: 600;
    cursor: pointer;
    &:first-child {
      color: var(--secondary-500);
      background-color: transparent;
      border: 1px solid var(--secondary-500);
    }
    &:last-child {
      margin-left: 12px;
      color: var(--grey-900);
      background-color: var(--primary-500);
      border: 1px solid var(--primary-500);
      &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
      }
    }
  }
`;

export default withRouter(NoticeCreate);
